var _g, _g2, _g3, _g4, _g5, _g6, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectiveSocializingWithFriends(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 146,
    viewBox: "0 0 279 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_11322_9743",
    maskUnits: "userSpaceOnUse",
    x: 129.479,
    y: 70.4342,
    width: 59.5607,
    height: 56.7773,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 129.479,
    y: 70.4342,
    width: 59.5607,
    height: 56.7773
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.897 77.9015C134.71 77.9845 133.815 79.0137 133.898 80.2004L136.002 110.281C136.085 111.467 137.114 112.362 138.301 112.279L148.506 111.565L149.083 119.807C149.216 121.721 151.598 122.518 152.857 121.07L161.935 110.626L181.273 109.274C182.459 109.191 183.354 108.162 183.271 106.975L181.167 76.895C181.085 75.7083 180.055 74.8136 178.869 74.8966L135.897 77.9015Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.897 77.9015C134.71 77.9845 133.815 79.0137 133.898 80.2004L136.002 110.281C136.085 111.467 137.114 112.362 138.301 112.279L148.506 111.565L149.083 119.807C149.216 121.721 151.598 122.518 152.857 121.07L161.935 110.626L181.273 109.274C182.459 109.191 183.354 108.162 183.271 106.975L181.167 76.895C181.085 75.7083 180.055 74.8136 178.869 74.8966L135.897 77.9015Z",
    fill: "#F83232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.897 77.9015L136.176 81.8918L135.897 77.9015ZM138.301 112.279L138.022 108.289L138.301 112.279ZM148.506 111.565L152.497 111.286C152.342 109.083 150.431 107.421 148.227 107.575L148.506 111.565ZM152.857 121.07L155.876 123.694L155.876 123.694L152.857 121.07ZM161.935 110.626L161.656 106.636C160.598 106.71 159.612 107.202 158.916 108.002L161.935 110.626ZM181.273 109.274L181.552 113.264L181.273 109.274ZM183.271 106.975L179.281 107.254L183.271 106.975ZM181.167 76.895L185.158 76.6159L181.167 76.895ZM178.869 74.8966L178.59 70.9064L178.869 74.8966ZM137.889 79.9213C137.96 80.9385 137.193 81.8206 136.176 81.8918L135.618 73.9113C132.227 74.1483 129.671 77.089 129.908 80.4794L137.889 79.9213ZM139.992 110.002L137.889 79.9213L129.908 80.4794L132.011 110.56L139.992 110.002ZM138.022 108.289C139.039 108.218 139.921 108.985 139.992 110.002L132.011 110.56C132.249 113.95 135.189 116.506 138.58 116.269L138.022 108.289ZM148.227 107.575L138.022 108.289L138.58 116.269L148.785 115.556L148.227 107.575ZM153.073 119.528L152.497 111.286L144.516 111.844L145.092 120.086L153.073 119.528ZM149.838 118.446C150.917 117.204 152.958 117.887 153.073 119.528L145.092 120.086C145.475 125.555 152.279 127.832 155.876 123.694L149.838 118.446ZM158.916 108.002L149.838 118.446L155.876 123.694L164.954 113.251L158.916 108.002ZM180.994 105.284L161.656 106.636L162.214 114.617L181.552 113.264L180.994 105.284ZM179.281 107.254C179.21 106.237 179.976 105.355 180.994 105.284L181.552 113.264C184.942 113.027 187.498 110.087 187.261 106.696L179.281 107.254ZM177.177 77.174L179.281 107.254L187.261 106.696L185.158 76.6159L177.177 77.174ZM179.148 78.8869C178.131 78.958 177.248 78.1911 177.177 77.174L185.158 76.6159C184.921 73.2256 181.98 70.6693 178.59 70.9064L179.148 78.8869ZM136.176 81.8918L179.148 78.8869L178.59 70.9064L135.618 73.9113L136.176 81.8918Z",
    fill: "#F0F0F0",
    mask: "url(#path-1-outside-1_11322_9743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.88 96.0257L146.579 91.7285",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.514 94.3724L170.214 90.0752",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.922 98.4239L158.171 87.6787",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_11322_9743",
    maskUnits: "userSpaceOnUse",
    x: 88.4368,
    y: 2.44222,
    width: 58.6971,
    height: 55.8582,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 88.4368,
    y: 2.44222,
    width: 58.6971,
    height: 55.8582
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7915 9.04548C93.6036 9.10774 92.6911 10.1212 92.7533 11.3091L94.3315 41.4216C94.3937 42.6095 95.4072 43.522 96.5951 43.4598L106.812 42.9243L107.244 51.1749C107.345 53.0912 109.712 53.9294 110.996 52.5034L120.255 42.2198L139.613 41.2053C140.801 41.1431 141.713 40.1296 141.651 38.9417L140.073 8.82918C140.011 7.64127 138.997 6.72875 137.809 6.79101L94.7915 9.04548Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.7915 9.04548C93.6036 9.10774 92.6911 10.1212 92.7533 11.3091L94.3315 41.4216C94.3937 42.6095 95.4072 43.522 96.5951 43.4598L106.812 42.9243L107.244 51.1749C107.345 53.0912 109.712 53.9294 110.996 52.5034L120.255 42.2198L139.613 41.2053C140.801 41.1431 141.713 40.1296 141.651 38.9417L140.073 8.82918C140.011 7.64127 138.997 6.72875 137.809 6.79101L94.7915 9.04548Z",
    fill: "#F83232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7533 11.3091L96.7479 11.0998L92.7533 11.3091ZM94.3315 41.4216L90.337 41.631L94.3315 41.4216ZM96.5951 43.4598L96.3858 39.4653L96.5951 43.4598ZM106.812 42.9243L110.806 42.715C110.691 40.5089 108.809 38.8142 106.603 38.9298L106.812 42.9243ZM107.244 51.1749L111.239 50.9656L107.244 51.1749ZM110.996 52.5034L108.023 49.8269L108.023 49.8269L110.996 52.5034ZM120.255 42.2198L120.046 38.2253C118.987 38.2808 117.993 38.7549 117.283 39.5433L120.255 42.2198ZM96.7479 11.0998C96.8012 12.118 96.0191 12.9866 95.0009 13.04L94.5822 5.05096C91.1882 5.22883 88.581 8.12442 88.7588 11.5184L96.7479 11.0998ZM98.326 41.2123L96.7479 11.0998L88.7588 11.5184L90.337 41.631L98.326 41.2123ZM96.3858 39.4653C97.404 39.4119 98.2726 40.1941 98.326 41.2123L90.337 41.631C90.5148 45.025 93.4104 47.6322 96.8044 47.4543L96.3858 39.4653ZM106.603 38.9298L96.3858 39.4653L96.8044 47.4543L107.021 46.9189L106.603 38.9298ZM111.239 50.9656L110.806 42.715L102.817 43.1337L103.25 51.3843L111.239 50.9656ZM108.023 49.8269C109.124 48.6046 111.153 49.3231 111.239 50.9656L103.25 51.3843C103.537 56.8592 110.3 59.2542 113.968 55.1799L108.023 49.8269ZM117.283 39.5433L108.023 49.8269L113.968 55.1799L123.228 44.8963L117.283 39.5433ZM139.404 37.2108L120.046 38.2253L120.465 46.2143L139.822 45.1998L139.404 37.2108ZM137.657 39.151C137.603 38.1328 138.385 37.2642 139.404 37.2108L139.822 45.1998C143.216 45.022 145.824 42.1264 145.646 38.7324L137.657 39.151ZM136.079 9.03852L137.657 39.151L145.646 38.7324L144.068 8.61983L136.079 9.03852ZM138.019 10.7855C137.001 10.8389 136.132 10.0567 136.079 9.03852L144.068 8.61983C143.89 5.22583 140.994 2.61862 137.6 2.79649L138.019 10.7855ZM95.0009 13.04L138.019 10.7855L137.6 2.79649L94.5822 5.05096L95.0009 13.04Z",
    fill: "#F0F0F0",
    mask: "url(#path-6-outside-2_11322_9743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.456 27.3584L105.23 23.0566",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.116 26.1182L128.891 21.8164",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.455 29.9666L116.892 19.21",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-outside-3_11322_9743",
    maskUnits: "userSpaceOnUse",
    x: 48.6116,
    y: 29.4714,
    width: 55.7492,
    height: 54.0866,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 48.6116,
    y: 29.4714,
    width: 55.7492,
    height: 54.0866
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1125 34.3367C60.1054 34.1772 59.1598 34.8642 59.0003 35.8713L54.957 61.3992C54.7975 62.4063 55.4846 63.3519 56.4917 63.5114L65.1533 64.8833L64.0455 71.8776C63.7882 73.5021 65.6234 74.6268 66.954 73.66L76.5497 66.6883L92.9601 69.2875C93.9672 69.447 94.9129 68.7599 95.0724 67.7529L99.1156 42.2249C99.2751 41.2179 98.588 40.2722 97.581 40.1127L61.1125 34.3367Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1125 34.3367C60.1054 34.1772 59.1598 34.8642 59.0003 35.8713L54.957 61.3992C54.7975 62.4063 55.4846 63.3519 56.4917 63.5114L65.1533 64.8833L64.0455 71.8776C63.7882 73.5021 65.6234 74.6268 66.954 73.66L76.5497 66.6883L92.9601 69.2875C93.9672 69.447 94.9129 68.7599 95.0724 67.7529L99.1156 42.2249C99.2751 41.2179 98.588 40.2722 97.581 40.1127L61.1125 34.3367Z",
    fill: "#F83232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1125 34.3367L60.4867 38.2874L61.1125 34.3367ZM65.1533 64.8833L69.104 65.509C69.4496 63.3271 67.9609 61.2781 65.779 60.9326L65.1533 64.8833ZM66.954 73.66L64.6029 70.4239L64.6029 70.4239L66.954 73.66ZM76.5497 66.6883L77.1754 62.7376C76.1276 62.5716 75.0568 62.8287 74.1986 63.4523L76.5497 66.6883ZM92.9601 69.2875L93.5859 65.3367L92.9601 69.2875ZM95.0724 67.7529L91.1216 67.1271L95.0724 67.7529ZM99.1156 42.2249L103.066 42.8507L99.1156 42.2249ZM97.581 40.1127L98.2067 36.1619L97.581 40.1127ZM62.951 36.497C62.7649 37.6719 61.6616 38.4735 60.4867 38.2874L61.7382 30.3859C58.5492 29.8808 55.5546 32.0565 55.0495 35.2455L62.951 36.497ZM58.9078 62.025L62.951 36.497L55.0495 35.2455L51.0063 60.7735L58.9078 62.025ZM57.1174 59.5607C58.2923 59.7468 59.0939 60.8501 58.9078 62.025L51.0063 60.7735C50.5012 63.9625 52.6769 66.9571 55.8659 67.4622L57.1174 59.5607ZM65.779 60.9326L57.1174 59.5607L55.8659 67.4622L64.5275 68.8341L65.779 60.9326ZM67.9962 72.5034L69.104 65.509L61.2025 64.2576L60.0947 71.2519L67.9962 72.5034ZM64.6029 70.4239C66.1553 69.2961 68.2964 70.6081 67.9962 72.5034L60.0947 71.2519C59.2799 76.3961 65.0915 79.9575 69.3052 76.8961L64.6029 70.4239ZM74.1986 63.4523L64.6029 70.4239L69.3052 76.8961L78.9009 69.9244L74.1986 63.4523ZM93.5859 65.3367L77.1754 62.7376L75.924 70.6391L92.3344 73.2382L93.5859 65.3367ZM91.1216 67.1271C91.3077 65.9522 92.411 65.1507 93.5859 65.3367L92.3344 73.2382C95.5234 73.7433 98.518 71.5676 99.0231 68.3786L91.1216 67.1271ZM95.1648 41.5992L91.1216 67.1271L99.0231 68.3786L103.066 42.8507L95.1648 41.5992ZM96.9552 44.0634C95.7804 43.8774 94.9788 42.7741 95.1648 41.5992L103.066 42.8507C103.571 39.6617 101.396 36.667 98.2067 36.1619L96.9552 44.0634ZM60.4867 38.2874L96.9552 44.0634L98.2067 36.1619L61.7382 30.3859L60.4867 38.2874Z",
    fill: "#F0F0F0",
    mask: "url(#path-11-outside-3_11322_9743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7906 51.5912L67.3682 47.9443",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8492 54.7679L87.4268 51.1211",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3858 55.9168L77.8301 46.7979",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-16-outside-4_11322_9743",
    maskUnits: "userSpaceOnUse",
    x: 81.3446,
    y: 56.4778,
    width: 59.5607,
    height: 56.7773,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 81.3446,
    y: 56.4778,
    width: 59.5607,
    height: 56.7773
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9015 60.8973C89.7149 60.8143 88.6857 61.709 88.6027 62.8957L86.4993 92.9761C86.4163 94.1627 87.311 95.1919 88.4976 95.2749L98.7037 95.9886L98.1274 104.23C97.9935 106.145 100.241 107.265 101.689 106.006L112.133 96.9276L131.47 98.2798C132.656 98.3628 133.685 97.4681 133.768 96.2814L135.872 66.2011C135.955 65.0144 135.06 63.9852 133.874 63.9022L90.9015 60.8973Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9015 60.8973C89.7149 60.8143 88.6857 61.709 88.6027 62.8957L86.4993 92.9761C86.4163 94.1627 87.311 95.1919 88.4976 95.2749L98.7037 95.9886L98.1274 104.23C97.9935 106.145 100.241 107.265 101.689 106.006L112.133 96.9276L131.47 98.2798C132.656 98.3628 133.685 97.4681 133.768 96.2814L135.872 66.2011C135.955 65.0144 135.06 63.9852 133.874 63.9022L90.9015 60.8973Z",
    fill: "#F83232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7037 95.9886L102.694 96.2676C102.848 94.0639 101.187 92.1524 98.9827 91.9983L98.7037 95.9886ZM101.689 106.006L99.0648 102.987L99.0648 102.987L101.689 106.006ZM112.133 96.9276L112.412 92.9374C111.353 92.8634 110.309 93.2128 109.508 93.9088L112.133 96.9276ZM131.47 98.2798L131.191 102.27L131.47 98.2798ZM92.5929 63.1747C92.5218 64.1918 91.6396 64.9587 90.6225 64.8876L91.1806 56.9071C87.7902 56.67 84.8495 59.2262 84.6124 62.6166L92.5929 63.1747ZM90.4895 93.2551L92.5929 63.1747L84.6124 62.6166L82.509 92.697L90.4895 93.2551ZM88.7766 91.2847C89.7938 91.3558 90.5606 92.238 90.4895 93.2551L82.509 92.697C82.2719 96.0874 84.8282 99.0281 88.2186 99.2652L88.7766 91.2847ZM98.9827 91.9983L88.7766 91.2847L88.2186 99.2652L98.4247 99.9788L98.9827 91.9983ZM102.118 104.509L102.694 96.2676L94.7135 95.7096L94.1371 103.951L102.118 104.509ZM99.0648 102.987C100.306 101.908 102.232 102.869 102.118 104.509L94.1371 103.951C93.7547 109.42 100.176 112.622 104.313 109.025L99.0648 102.987ZM109.508 93.9088L99.0648 102.987L104.313 109.025L114.757 99.9465L109.508 93.9088ZM131.749 94.2895L112.412 92.9374L111.854 100.918L131.191 102.27L131.749 94.2895ZM129.778 96.0024C129.849 94.9853 130.732 94.2184 131.749 94.2895L131.191 102.27C134.581 102.507 137.522 99.9509 137.759 96.5605L129.778 96.0024ZM131.882 65.922L129.778 96.0024L137.759 96.5605L139.862 66.4801L131.882 65.922ZM133.594 67.8925C132.577 67.8213 131.81 66.9391 131.882 65.922L139.862 66.4801C140.099 63.0897 137.543 60.149 134.153 59.912L133.594 67.8925ZM90.6225 64.8876L133.594 67.8925L134.153 59.912L91.1806 56.9071L90.6225 64.8876Z",
    fill: "#F0F0F0",
    mask: "url(#path-16-outside-4_11322_9743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2552 80.3734L99.5557 76.0762",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.89 82.0257L123.19 77.7285",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.846 84.4239L111.598 73.6787",
    stroke: "white",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-21-outside-5_11322_9743",
    maskUnits: "userSpaceOnUse",
    x: 132.647,
    y: 15.5055,
    width: 52.9099,
    height: 51.0918,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 132.647,
    y: 15.5055,
    width: 52.9099,
    height: 51.0918
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.219 19.9998C141.203 19.9109 140.308 20.6623 140.219 21.678L137.966 47.4258C137.877 48.4415 138.629 49.337 139.645 49.4258L148.38 50.1901L147.763 57.2447C147.62 58.8832 149.529 59.8771 150.789 58.8199L159.875 51.1958L176.427 52.6439C177.443 52.7328 178.338 51.9814 178.427 50.9657L180.68 25.2179C180.769 24.2021 180.017 23.3067 179.002 23.2178L142.219 19.9998Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.219 19.9998C141.203 19.9109 140.308 20.6623 140.219 21.678L137.966 47.4258C137.877 48.4415 138.629 49.337 139.645 49.4258L148.38 50.1901L147.763 57.2447C147.62 58.8832 149.529 59.8771 150.789 58.8199L159.875 51.1958L176.427 52.6439C177.443 52.7328 178.338 51.9814 178.427 50.9657L180.68 25.2179C180.769 24.2021 180.017 23.3067 179.002 23.2178L142.219 19.9998Z",
    fill: "#F83232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.38 50.1901L152.365 50.5387C152.558 48.338 150.93 46.3979 148.729 46.2053L148.38 50.1901ZM150.789 58.8199L153.36 61.8841L153.36 61.884L150.789 58.8199ZM159.875 51.1958L160.224 47.211C159.167 47.1185 158.117 47.4497 157.304 48.1316L159.875 51.1958ZM176.427 52.6439L176.776 48.6591L176.427 52.6439ZM144.204 22.0266C144.1 23.2116 143.055 24.0882 141.87 23.9845L142.568 16.015C139.351 15.7336 136.516 18.1129 136.234 21.3294L144.204 22.0266ZM141.951 47.7744L144.204 22.0266L136.234 21.3294L133.982 47.0772L141.951 47.7744ZM139.993 45.4411C141.178 45.5447 142.055 46.5894 141.951 47.7744L133.982 47.0772C133.7 50.2936 136.079 53.1292 139.296 53.4106L139.993 45.4411ZM148.729 46.2053L139.993 45.4411L139.296 53.4106L148.032 54.1749L148.729 46.2053ZM151.748 57.5934L152.365 50.5387L144.396 49.8415L143.778 56.8961L151.748 57.5934ZM148.218 55.7557C149.688 54.5223 151.915 55.6818 151.748 57.5934L143.778 56.8961C143.324 62.0847 149.37 65.2319 153.36 61.8841L148.218 55.7557ZM157.304 48.1316L148.218 55.7557L153.36 61.884L162.446 54.2599L157.304 48.1316ZM176.776 48.6591L160.224 47.211L159.526 55.1805L176.079 56.6287L176.776 48.6591ZM174.442 50.617C174.546 49.432 175.591 48.5554 176.776 48.6591L176.079 56.6287C179.295 56.9101 182.131 54.5307 182.412 51.3143L174.442 50.617ZM176.695 24.8692L174.442 50.617L182.412 51.3143L184.665 25.5665L176.695 24.8692ZM178.653 27.2026C177.468 27.0989 176.591 26.0543 176.695 24.8692L184.665 25.5665C184.946 22.35 182.567 19.5145 179.35 19.233L178.653 27.2026ZM141.87 23.9845L178.653 27.2026L179.35 19.233L142.568 16.015L141.87 23.9845Z",
    fill: "#F0F0F0",
    mask: "url(#path-21-outside-5_11322_9743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.086 36.816L149.408 33.1377",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.317 38.5865L169.639 34.9082",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.96 40.4622L159.765 31.2646",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11322_9743)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-26-outside-6_11322_9743",
    maskUnits: "userSpaceOnUse",
    x: 164.529,
    y: 42.4803,
    width: 55.0643,
    height: 53.3621,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 164.529,
    y: 42.4803,
    width: 55.0643,
    height: 53.3621
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.819 47.255C208.829 47.1131 209.762 47.8166 209.904 48.8262L213.501 74.4209C213.643 75.4305 212.94 76.3641 211.93 76.506L203.246 77.7264L204.232 84.7387C204.461 86.3675 202.606 87.4599 201.292 86.4701L191.82 79.3322L175.366 81.6447C174.357 81.7866 173.423 81.0831 173.281 80.0734L169.684 54.4788C169.542 53.4691 170.246 52.5356 171.256 52.3937L207.819 47.255Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.819 47.255C208.829 47.1131 209.762 47.8166 209.904 48.8262L213.501 74.4209C213.643 75.4305 212.94 76.3641 211.93 76.506L203.246 77.7264L204.232 84.7387C204.461 86.3675 202.606 87.4599 201.292 86.4701L191.82 79.3322L175.366 81.6447C174.357 81.7866 173.423 81.0831 173.281 80.0734L169.684 54.4788C169.542 53.4691 170.246 52.5356 171.256 52.3937L207.819 47.255Z",
    fill: "#F83232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.904 48.8262L213.865 48.2695L209.904 48.8262ZM213.501 74.4209L209.54 74.9775L213.501 74.4209ZM211.93 76.506L211.374 72.5449L211.93 76.506ZM203.246 77.7264L199.285 78.2831C198.978 76.0955 200.502 74.0728 202.69 73.7654L203.246 77.7264ZM204.232 84.7387L200.271 85.2954L204.232 84.7387ZM201.292 86.4701L203.7 83.2755L203.7 83.2755L201.292 86.4701ZM191.82 79.3322L191.264 75.3712C192.314 75.2235 193.38 75.4993 194.228 76.1377L191.82 79.3322ZM205.943 49.3829C206.109 50.5609 207.198 51.3816 208.376 51.2161L207.263 43.2939C210.46 42.8446 213.416 45.0722 213.865 48.2695L205.943 49.3829ZM209.54 74.9775L205.943 49.3829L213.865 48.2695L217.463 73.8642L209.54 74.9775ZM211.374 72.5449C210.196 72.7105 209.375 73.7996 209.54 74.9775L217.463 73.8642C217.912 77.0615 215.684 80.0177 212.487 80.467L211.374 72.5449ZM202.69 73.7654L211.374 72.5449L212.487 80.467L203.803 81.6875L202.69 73.7654ZM200.271 85.2954L199.285 78.2831L207.207 77.1697L208.193 84.182L200.271 85.2954ZM203.7 83.2755C202.167 82.1207 200.004 83.3952 200.271 85.2954L208.193 84.182C208.918 89.3397 203.045 92.7991 198.885 89.6646L203.7 83.2755ZM194.228 76.1377L203.7 83.2755L198.885 89.6646L189.413 82.5268L194.228 76.1377ZM174.81 77.6836L191.264 75.3712L192.377 83.2933L175.923 85.6057L174.81 77.6836ZM177.242 79.5167C177.077 78.3388 175.988 77.5181 174.81 77.6836L175.923 85.6057C172.726 86.0551 169.77 83.8274 169.32 80.6301L177.242 79.5167ZM173.645 53.9221L177.242 79.5167L169.32 80.6301L165.723 55.0355L173.645 53.9221ZM171.812 56.3548C172.99 56.1892 173.811 55.1001 173.645 53.9221L165.723 55.0355C165.274 51.8382 167.502 48.882 170.699 48.4326L171.812 56.3548ZM208.376 51.2161L171.812 56.3548L170.699 48.4326L207.263 43.2939L208.376 51.2161Z",
    fill: "#F0F0F0",
    mask: "url(#path-26-outside-6_11322_9743)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.841 64.4083L201.327 60.752",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.731 67.2345L181.217 63.5781",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.172 68.5657L190.887 59.4229",
    stroke: "white",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 88C61 86.8954 61.8954 86 63 86H83.2654C84.2607 86 85.1046 86.7319 85.2453 87.7172L88.7547 112.283C88.8954 113.268 89.7393 114 90.7346 114H191.265C192.261 114 193.105 113.268 193.245 112.283L196.755 87.7172C196.895 86.7319 197.739 86 198.735 86H219C220.105 86 221 86.8954 221 88V114V140C221 141.105 220.105 142 219 142H189H93H63C61.8954 142 61 141.105 61 140V114V88Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 121.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.5,
    cy: 42.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 3.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 277.5,
    cy: 107.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 2.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 33 146)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M201.5 29L226.5 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 70.5L255 74.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6.5L51 15.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 80.5L37 76.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(129 71.9062) rotate(-4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(88 2.93066) rotate(-3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(56.5088 28) rotate(9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(84.9062 54) rotate(4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(137.184 14) rotate(5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11322_9743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "matrix(-0.990268 0.139173 0.139173 0.990268 212.533 41)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveSocializingWithFriends);
export default __webpack_public_path__ + "static/media/collective-socializing-with-friends.3f5b9174261d55fa00cadf3d5ca3054b.svg";
export { ForwardRef as ReactComponent };